import React from "react";

function PunjabEntryToPrisoner() {
  return (
    <div className="bg-punjab-entry-to-prisoner py-5">
      <div className="container">
        <div>
          <h2 className="text-h-black text-light">Upon Entering the Prison</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “I was beaten in Jhelum on my first day. There’s no reason
                  given for this, it’s part of the process of entry [a rite of
                  passage into jail].”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Farooq Amjad</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “When I first went to jail, my religion became a big problem.
                  I was tortured and called a chura. No one ever called me by my
                  name.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Sohail Yafat</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “When I arrived at Kot Lakhpat, a friend there told me, ‘this
                  is not Kot Lakhpat, it’s Kot Lakh Lanat’ – the jail of a
                  hundred thousand curses.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Rashid Masih</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PunjabEntryToPrisoner;
